import { useState, useEffect } from 'react';
import './translations/i18n';
import './styles/globals.css';

import Navbar       from './components/layout/Navbar';
import Footer       from './components/layout/Footer';
import HomePage     from './pages/HomePage';
import AboutPage    from './pages/AboutPage';
import ProgrammesPage from './pages/ProgrammesPage';
import ActionsPage  from './pages/ActionsPage';
import ImpactPage   from './pages/ImpactPage';
import PartnersPage from './pages/PartnersPage';
import ContactPage  from './pages/ContactPage';

const ROUTES = {
  '/':           HomePage,
  '/quem-somos': AboutPage,
  '/programas':  ProgrammesPage,
  '/accoes':     ActionsPage,
  '/impacto':    ImpactPage,
  '/parceiros':  PartnersPage,
  '/contacto':   ContactPage,
};

export default function App() {
  const [page, setPage] = useState('/');

  const navigate = (href) => {
    const base = (href || '/').split('#')[0];
    const target = ROUTES[base] ? base : '/';
    setPage(target);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const Page = ROUTES[page] || HomePage;

  return (
    <div className="min-h-screen font-sora antialiased">
      <Navbar onNavigate={navigate} currentPage={page} />
      <Page onNavigate={navigate} />
      <Footer onNavigate={navigate} />
    </div>
  );
}
